export default __webpack_public_path__ + "static/media/eth-orange.d2310b8f.svg";